/**
 * Insumos da Ficha Técnica — componente, produto, quantidade e tipo de consumo.
 * Subcoleção: org/{orgId}/technical-sheet/{technicalSheetId}/material
 */
export const TECHNICAL_SHEET_MATERIAL = 'TechnicalSheetMaterial';
export const ConsumptionTypeValues = ['Linear', 'Lote', 'Fixo'];
/**
 * Whether `quantityPerBatchOrFixed` is required for a given consumption type.
 * Required for 'Lote' (per-batch quantity) and 'Fixo' (fixed value); not for 'Linear'.
 * Single source of truth for UI, validators, and services.
 */
export function requiresQuantityPerBatchOrFixed(consumptionType) {
    return consumptionType === 'Lote' || consumptionType === 'Fixo';
}
//# sourceMappingURL=technical-sheet-material.js.map